import {type Struct} from '@wandb/weave/common/util/types';
import BokehViewer from '@wandb/weave/components/Panel2/BokehViewer';
import * as React from 'react';
import {useLayoutEffect, useState} from 'react';

import {labelComponent} from '../util/media';
import {InstrumentedCenteredWaveLoader as Loader} from './../components/utility/InstrumentedLoader';
import {type MediaCardProps} from './MediaCard';
import MessageMediaNotFound from './MessageMediaNotFound';
import {SingleRunLink} from './MultiRunWorkspace/SingleRunMode';

const BokehCard = React.memo((props: MediaCardProps) => {
  const {
    run,
    globalStep,
    mediaKey,
    mediaIndex,
    runSignature,
    tileMedia,
    loading,
    customRunName,
  } = props;
  const blob = tileMedia?.blob;

  const [bokehJson, setBokehJson] = useState<Struct | null>(null);
  useLayoutEffect(() => {
    if (blob == null) {
      return;
    }
    (async () => {
      try {
        const fileText = await new Response(blob).text();
        setBokehJson(JSON.parse(fileText));
      } catch {
        // TODO(axel): show error state for bad Bokeh file
      }
    })();
  }, [blob]);

  const titleLink = (
    <SingleRunLink
      {...runSignature}
      linkText={customRunName ?? run.displayName}
    />
  );

  return loading ? (
    <Loader name="panel-content-loader" size="small" />
  ) : (
    <BokehViewer
      headerElements={labelComponent(props, tileMedia?.step, titleLink)}
      notFoundElements={[
        <MessageMediaNotFound
          key={mediaKey}
          mediaKey={mediaKey}
          stepIndex={globalStep}
          mediaIndex={mediaIndex}
          mediaType="bokeh"
        />,
      ]}
      contentNotFound={tileMedia == null}
      bokehJson={bokehJson}
    />
  );
});

export default BokehCard;
